import moment from "moment";

export const localStorageItemNames = {
  TOKEN: "token",
  USER_ID: "userId",
  USER_TYPE: "userType",
  USER_EMAIL: "userEmail",
  ROLE: "role",
  NAME: "name"
};

export const dateFormat = (date, format = "YYYY-MM-DD") => {
  return moment(date).format(format);
};


export const requiredField = (field) => {
  return `${field} is required`;
};


export const formField = {
  // User
  email: { label: "Email", name: "email" },
  password: { label: "Password", name: "password" },
  first_name: { label: "First Name", name: "first_name" },
  last_name: { label: "Last Name", name: "last_name" },
  email_id: { label: "Email ID", name: "email_id" },
  profile_picture: { label: "Profile Picture", name: "profile_picture" },
  type: { label: "Type", name: "type" },
  status: { label: "Status", name: "status" },
  verified_status: { label: "Verified Status", name: "verified_status" },
  user_name: { label: "User Name", name: "user_name" },
  action: { label: "Action", name: "Action" },
  title: { label: "Title", name: "title" },
  description: { label: "Description", name: "description" },
  medium: { label: "Medium", name: "medium" },
  notes: { label: "Notes", name: "notes" },
  views: { label: "Views", name: "views" },
  ratings: { label: "Ratings", name: "ratings" },
  select_type: { label: "Select Type", name: "select_type" },
  share_exp_via: { label: "Share Experience Via", name: "share_exp_via" },
  budget_min: { label: "Budget Min", name: "budget_min" },
  budget_max: { label: "Budget Max", name: "budget_max" },
  location: { label: "Location", name: "location" },
  createdAt: { label: "Created At", name: "createdAt" },
  video_link: { label: "Video Link", name: "video_link" },
  proof_images: { label: "Proof Images", name: "proof_images" },
  proof_documents: { label: "Proof Documents", name: "proof_documents" },
  message: { label: "Message", name: "message" },
  next_step: { label: "Next Step", name: "next_step" },

  reschedule_count: { label: "Reschedule Count", name: "reschedule_count" },
  cancellation_before: { label: "Cancellation Before (hrs)", name: "cancellation_before" },
  percentage_deduction_refund_after_cutoff: { label: "Refund Deduction (%)", name: "percentage_deduction_refund_after_cutoff" },
  commission_percentage: { label: "Commission (%)", name: "commission_percentage" },
  gst_percentage: { label: "GST (%)", name: "gst_percentage" },
  additional_tax_percentage: { label: "Additional Tax (%)", name: "additional_tax_percentage" },
  payout_date: { label: "Payout Date", name: "payout_date" },
  suspend_duration: { label: "Suspend Duration (days)", name: "suspend_duration" },
  category: { label: "Category", name: "category" },
  min_payout_amount:{label: "Minimum Payout Amount", name: "min_payout_amount"},


  time: { label: "Time", name: "time" },
  word: { label: "Word", name: "word" },
  reportDescription: { label: "Report Description", name: "reportDescription" },
  topic: { label: "Topic", name: "topic" },
};
